import React, { useEffect, useState } from 'react';
import './CadastroLead.css';

function CadastroLead() {
  const hoje = new Date();
hoje.setMinutes(hoje.getMinutes() - hoje.getTimezoneOffset()); // Ajusta para o fuso horário local
const dataHoje = hoje.toISOString().split("T")[0]; // Obtém apenas YYYY-MM-DD


  const [formData, setFormData] = useState({
    nome: '',
    telefone: '',
    origem_lead: '',
    interesse: '',
    data_primeiro_contato: dataHoje,
    estagio_funil: '',
    observacao: '',
    descricao_acao: '',
    data_proxima_acao: '',
  });

  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [tagsDisponiveis, setTagsDisponiveis] = useState([]);
  const [tagsSelecionadas, setTagsSelecionadas] = useState([]);


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');
    setError('');

    try {
      const response = await fetch('https://welaunchyou.com.br/crm-wly/cadastro_lead.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify({ ...formData, tags: tagsSelecionadas }),
      });

      const data = await response.json();

      if (response.ok) {
        setMessage(data.message);
        setFormData({
          nome: '',
          telefone: '',
          origem_lead: '',
          interesse: '',
          data_primeiro_contato: '',
          estagio_funil: '',
          observacao: '',
          descricao_acao: '',
          data_proxima_acao: '',
        });
      } else {
        setError(data.error || 'Erro ao cadastrar lead.');
      }
    } catch (err) {
      setError('Erro ao se conectar ao servidor.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
  const carregarTags = async () => {
    try {
      const res = await fetch("https://welaunchyou.com.br/crm-wly/tags.php?lista=1", {
        credentials: "include",
      });
      const data = await res.json();

      const lista = Array.isArray(data)
        ? data
        : Array.isArray(data.tags)
        ? data.tags
        : Array.isArray(data.resumo)
        ? data.resumo
        : [];

      setTagsDisponiveis(lista);
    } catch (err) {
      console.error("Erro ao carregar tags:", err);
      setTagsDisponiveis([]); 
    }
  };

  carregarTags();
}, []);


  return (
    <div className="cadastro">
     <h1>Cadastrar Lead</h1>


      <div className="main-container">
      <div className="cadastro-lead-container">
        

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="nome">Nome:</label>
            <input
              type="text"
              id="nome"
              name="nome"
              value={formData.nome}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="telefone">Telefone:</label>
            <input
              type="text"
              id="telefone"
              name="telefone"
              value={formData.telefone}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="origem_lead">Origem do Lead:</label>
            <select
              id="origem_lead"
              name="origem_lead"
              value={formData.origem_lead}
              onChange={handleChange}
              required
            >
              <option value="">Selecione</option>
              <option value="Facebook">Facebook</option>
              <option value="Instagram">Instagram</option>
              <option value="Google Ads">Google Ads</option>
              <option value="Indicação">Indicação</option>
              <option value="Nórea CRM">Nórea CRM</option>

            </select>
          </div>

          <div className="form-group">
            <label htmlFor="interesse">Interesse:</label>
            <input
              type="text"
              id="interesse"
              name="interesse"
              value={formData.interesse}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="data_primeiro_contato">Data do Primeiro Contato:</label>
            <input
              type="date"
              id="data_primeiro_contato"
              name="data_primeiro_contato"
              value={formData.data_primeiro_contato} // 🟢 Preenchido com a data de hoje
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="estagio_funil">Estágio do Funil:</label>
            <select
              id="estagio_funil"
              name="estagio_funil"
              value={formData.estagio_funil}
              onChange={handleChange}
              required
            >
              <option value="">Selecione</option>
              <option value="Contato Inicial">Contato Inicial</option>
              <option value="Qualificação">Qualificação</option>
              <option value="Agendamento">Agendamento</option>
              <option value="Acompanhamento">Acompanhamento</option>
              <option value="Agendado">Agendado</option>
              <option value="Cliente">Cliente</option>


            </select>
          </div>

          <div className="form-group">
            <label htmlFor="observacao">Observação:</label>
            <textarea
              id="observacao"
              name="observacao"
              value={formData.observacao}
              onChange={handleChange}
              rows="3"
            ></textarea>
          </div>

          <div className="form-group">
  <label>Tags (opcional):</label>
  <div className="checkbox-container">
    {(tagsDisponiveis || []).map(tag => (
      <label key={tag.id} className="checkbox-item">
        <input
          type="checkbox"
          value={tag.id}
          checked={tagsSelecionadas.includes(tag.id.toString())}
          onChange={(e) => {
            const tagId = e.target.value;
            setTagsSelecionadas((prev) =>
              e.target.checked
                ? [...prev, tagId]
                : prev.filter((id) => id !== tagId)
            );
          }}
        />
        {tag.nome}
      </label>
    ))}
  </div>
</div>



          <div className="form-group">
            <label htmlFor="descricao_acao">Descrição da Próxima Ação:</label>
            <textarea
              id="descricao_acao"
              name="descricao_acao"
              value={formData.descricao_acao}
              onChange={handleChange}
              rows="3"
            ></textarea>
          </div>

          <div className="form-group">
            <label htmlFor="data_proxima_acao">Data da Próxima Ação:</label>
            <input
              type="date"
              id="data_proxima_acao"
              name="data_proxima_acao"
              value={formData.data_proxima_acao}
              onChange={handleChange}
            />
          </div>

          {message && <p className="success-message">{message}</p>}
          {error && <p className="error-message">{error}</p>}

          <button type="submit" disabled={loading}>
            {loading ? 'Cadastrando...' : 'Cadastrar'}
          </button>
        </form>
      </div>
      </div>
    </div>
  );
}

export default CadastroLead;
